
export const ActivityItemPriceModes = {
    MARGIN: 1,
    FLAT_FEE: 2,
    SURCHARGE: 3
}

export const MARGIN = 'margin'
export const CHARGE = 'charge'
export const SURCHARGE_AMOUNT = 'surchargeAmount'

export const PRICING_MODES = {
    MARGIN: {
        name: 'Margin',
        id: 1
    },
    FLAT_FEE: {
        name: 'Flat Fee',
        id: 2
    },
    SURCHARGE: {
        name: 'Surcharge',
        id: 3
    }
}

export const COMPONENT_ORDER = {
    [PRICING_MODES.MARGIN.id]: [MARGIN, CHARGE],
    [PRICING_MODES.FLAT_FEE.id]: [CHARGE, MARGIN],
    [PRICING_MODES.SURCHARGE.id]: [SURCHARGE_AMOUNT, CHARGE],
}